import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import * as React from 'react';

interface IState {
  open: boolean;
  title?: string;
  content?: string;
  onAgreement?: () => void;
}

export interface IDialogProps {
  openDialog(title: string, content: string, onAgreement: () => void): void;
}

const withDialog = (WrappedComponent: any) => {
  return class AppDialog extends React.Component<any, IState> {
    public state: IState = {
      open: false,
    };

    public handleClose() {
      return () => {
        this.setState({ open: false });
      };
    }

    public handleAgree() {
      return () => {
        if (this.state.onAgreement) {
          this.state.onAgreement();
        }
        this.handleClose()();
      };
    }

    public render() {
      const openFn = (title: string, content: string, onAgreement: () => void) => {
        this.setState({
          title,
          content,
          onAgreement,
          open: true,
        });
      };
      return (
        <>
          <WrappedComponent openDialog={openFn} {...this.props} />
          <Dialog open={this.state.open} onClose={this.handleClose()}>
            <DialogTitle id="alert-dialog-title">{this.state.title}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {this.state.content}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose()} color="primary">
                Disagree
              </Button>
              <Button onClick={this.handleAgree()} color="primary" autoFocus={true}>
                Agree
              </Button>
            </DialogActions>
          </Dialog>
        </>
      );
    }
  };
};

export default withDialog;



// WEBPACK FOOTER //
// ./src/hoc/Dialog.tsx